import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { platformGetToken } from "./localStorageHelper";
import { SessionAuth, useSessionContext } from "supertokens-auth-react/recipe/session";
import { onLogout } from "./utils";
import { setupResponseInterceptor } from "./requestHandler";
import { toast } from "react-toastify";

const PlatformAuth = (props) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const sessionContext = useSessionContext();
    const [isLoaded, setIsLoaded] = useState(false)

    if (!isLoaded) {
        setIsLoaded(true)
        setupResponseInterceptor(navigate)
    }

    useEffect(() => {
        function checkToken() {
            const userToken = platformGetToken();
            if(sessionContext.doesSessionExist === true) {
    
                // Redirect when user is valid but has no token or token body is an object
                if (!userToken || userToken === 'undefined' || typeof sessionContext.accessTokenPayload.access_token === "object" ) {
                    setIsLoggedIn(false);
                    if(! toast.isActive("axios-error")) {
                        toast.error(<div><b>An error occurred</b><br />An error occurred validating your account. Ensure the API and Database are online and try again or contact support.</div>, {
                            theme: "dark",
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: true,
                            toastId: 'axios-error'
                        })
                    }
                    return onLogout();
                }
            } else if(sessionContext.doesSessionExist === false) {
    
                // Redirect on routes while no auth is given
                return navigate('/auth');
            }

            // Redirect is the account is all valid
            setIsLoggedIn(true);
        }
        checkToken();
    }, [sessionContext, navigate])


    return (
        //We reimplmenet super-tokens authchecks too.
        <SessionAuth>
            <React.Fragment>
                {
                    isLoggedIn ? props.children : null
                }
            </React.Fragment>
        </SessionAuth>
    );
}
export default PlatformAuth;